<script setup lang="ts">
import {onMounted, ref} from 'vue';
import {robloxBuyers} from '@/constants.js'

const speed = -0.5;
// Unshuffled here so SSR output and the client's initial (pre-hydration) render are
// identical - Math.random() during setup() would make the two independently computed
// orders differ almost certainly, breaking Vue's hydration match for this whole list.
// Shuffled after mount instead, a client-only lifecycle hook that never runs during SSR,
// so it's a normal reactive update on top of an already-hydrated tree, not a mismatch.
const items = ref(robloxBuyers.map((el, index) => {
    return{
        ...el,
        id: index,
        offset: 0,
    }
}));

const offset = ref(0);

onMounted(() => {
    items.value = items.value.slice().sort(() => Math.random() - 0.5);

    setInterval(() => {
        for(const item of items.value) {
            if(item.offset <= -(170 * (items.value.length / 2))) {
                item.offset = 0;
            }
            item.offset = item.offset + speed;
        }
    }, 16)
})
</script>

<template>
  <div class="w-full flex justify-center">
    <div class="latest-purchases-container max-w-[640px] max-md:max-w-full shadow-[4px_4px_12px_0_rgba(0,0,0,0.3)]">
      <div class="latest-purchases">
        <template v-for="item in items">
          <div :style="`transform: translateX(${item.offset}px)`" class="latest-purchases__card">
            <img :src='`/assets/img/roblox/latest-users/noFilter%20(${item.id+1}).webp`' class="latest-purchases__card-image" alt="roblox-man">
            <div class="latest-purchases__card-info">
              <p class="latest-purchases__card-robuxes">
                <img src="/assets/icons/robux.svg" alt="robux" class="shrink-0" style="width:20px;height:22px">
                {{item.robuxes}}
              </p>
              <p class="latest-purchases__card-nickname">
                {{item.username}}
              </p>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>

</template>
<style lang="css">
@reference "../../css/app.css";

.latest-purchases-container {
    @apply bg-deep-blue;
    padding-inline: 10px;
    padding-block: 38px;
    margin: 10px 10px 0;
    border-radius: 8px;
}

.latest-purchases {
    display: flex;
    overflow-x: auto;
    height: auto;
    min-height: auto;
    width: 100%;
    scrollbar-width: none;
}

.latest-purchases::-webkit-scrollbar {
    display: none;
}

.latest-purchases__card {
    box-sizing: border-box;
    padding-inline: 12px;
    display: flex;
    gap: 8px;
    border-right: 1px dashed #0369A1;
    align-items: center;
    flex-shrink: 0;

}

.latest-purchases__card-image {
    @apply bg-slate-200;
    width: 60px;
    height: 60px;
    flex-shrink: 0;
    border-radius: 50%;
}

.latest-purchases__card-info {
    display: flex;
    flex-direction: column;
    padding-inline: 10px;
    gap: 4px;
}

.latest-purchases__card-robuxes {
    display: flex;
    gap: 4px;
    font-family: 'Fira Sans', sans-serif;
    font-size: 16px;
    color: #BAE6FD;
    font-weight: 500;
    align-items: center;
    line-height: 120%;
}

.latest-purchases__card-nickname {
    font-family: 'Fira Sans', sans-serif;
    font-size: 16px;
    color: #BAE6FD;
    font-weight: 500;
    line-height: 120%;
  }
</style>
